import React from 'react';
import ResourceSelect from "./ResourceSelect";
import PricegroupSelect from "./PricegroupSelect";
import {formatDate} from "../Helpers";
import {formatPrice} from "../Format";
import {submitBooking} from "../Api";
import {Decimal} from "decimal.js";
import {TranslationContext} from "../translations/context";

const BookingBox = (props) => {
    const [selectedTimespan, setSelectedTimespan] = React.useState('');
    const [bookingEnd, setBookingEnd] = React.useState(null);
    const [bookingPrice, setBookingPrice] = React.useState(null);
    const [termsAndConditions, setTermsAndConditions] = React.useState(false);
    const [bikeSize, setBikeSize] = React.useState(false);
    const [termsAndConditionsError, setTermsAndConditionsError] = React.useState(false);
    const [bikeSizeError, setBikeSizeError] = React.useState(false);

    const {updateSelectedResource, selectedResource, location, apiBackend} = props;
    const {t} = React.useContext(TranslationContext);

    React.useEffect(() => {
        if (selectedResource && selectedResource.pricegroup['fee_' + selectedTimespan] === undefined) {
            setSelectedTimespan(null);
            setBookingPrice(null);
        }
        else {
            setBookingPrice(calculatePrice(selectedResource, selectedTimespan));
        }
    }, [selectedResource]);

    const handleSelectedResourceUpdate = (e) => {
        updateSelectedResource(parseInt(e.target.value));
    };

    const calculatePrice = (resource, timespan) => {
        if (!resource || !timespan)
            return null;
        return Decimal(resource.pricegroup['fee_' + timespan]);
    };

    const handleSelectedTimespanChange = (e) => {
        const value = e.target.value;
        if (value === 'none') {
            setSelectedTimespan('');
            setBookingEnd(null);
            setBookingPrice(null);
            return;
        }

        const value_translation = {
            day: 1,
            week: 7,
            month: 31,
            quarter: 92,
            year: 365,
            ten_years: 3650,
        }
        let end = new Date();
        end.setDate(end.getDate() + value_translation[value] + 1);
        end.setHours(0, 0, 0, 0);

        setSelectedTimespan(value);
        setBookingEnd(end);
        setBookingPrice(calculatePrice(selectedResource, value));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedResource && selectedTimespan && termsAndConditions && (!location.bike_size_information || bikeSize)) {
            submitBooking({
                location_id: location.id,
                resource_id: selectedResource.id,
                predefined_daterange: selectedTimespan
            }).then(() => {
                window.location.href = wc_add_to_cart_params.cart_url;
            });
        }
        else {
            setTermsAndConditionsError(!termsAndConditions);
            setBikeSizeError(location.bike_size_information && !bikeSize)
        }
    };

    return <>
        <div className="block">
            <label htmlFor="selector-resource" className="label">{t('resource')}</label>
            <div className="control select is-fullwidth">
                <ResourceSelect
                    location={location}
                    selectedResource={selectedResource}
                    handleSelectedResourceUpdate={handleSelectedResourceUpdate}
                />
            </div>
        </div>
        <div className="block">
            <label htmlFor="selector-timespan" className="label">{t('duration')}</label>
            <div className="control select is-fullwidth">
                <PricegroupSelect
                    selectedTimespan={selectedTimespan}
                    handleSelectedTimespanChange={handleSelectedTimespanChange}
                    selectedResource={selectedResource}
                />
            </div>
        </div>
        <div className="block">
            {bookingEnd && <p style={{marginBottom: '0.5em'}}>
                {t('booking_until')} {formatDate(bookingEnd)}, 24:00 {t('oclock')}
            </p>}
            {bookingPrice && <h3 style={{marginTop: 0}}>
                {t('price')}: {formatPrice(bookingPrice)}
            </h3>}
            {!!location.bike_size_information && <p>
                <label className="checkbox" style={{color: (bikeSizeError) ? '#f14668': 'inherit'}}>
                    <input
                        type="checkbox"
                        onChange={() => setBikeSize(!bikeSize)}
                        value={bikeSize}
                    />
                    {' '}{location.bike_size_information}
                </label>
            </p>}
            <p>
                <label className="checkbox" style={{color: (termsAndConditionsError) ? '#f14668': 'inherit'}}>
                    <input
                        type="checkbox"
                        onChange={() => setTermsAndConditions(!termsAndConditions)}
                        value={termsAndConditions}
                    />
                    {' '}{t('tos_prefix')}{' '}
                    <a
                        href={location.terms_and_conditions}
                        target={'_blank'}
                        onClick={evt => evt.stopPropagation()}
                    >
                        {t('tos')}
                    </a>
                    {' '}{t('tos_postfix')}
                </label>
            </p>

            <button
                onClick={handleSubmit}
                className={`button is-fullwidth ${(selectedResource && selectedTimespan) ? 'is-success' : ''}`}
                disabled={!(selectedResource && selectedTimespan)}
            >
                {t('book')}
            </button>
        </div>
    </>
};

export default BookingBox;
